import { render, staticRenderFns } from "./spcodaccountcard.vue?vue&type=template&id=18ef930d"
import script from "./spcodaccountcard.vue?vue&type=script&lang=js"
export * from "./spcodaccountcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports